import { IHelps, setHelps } from 'src/actions/help';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

/**
 * ヘルプ画面のState型
 */
export type IHelpState = IHelps;

/**
 * ヘルプ画面のState初期値
 */
const initialState: IHelpState = {
	participant: [],
	participantCM: [],
	participantEM: [],
};

/**
 * ユーザ情報画面用reducer
 * @param state State
 * @param action アクション
 */
const help = reducerWithInitialState(initialState).case(
	setHelps,
	(_, payload) => ({
		...payload,
	})
);

export default help;



// WEBPACK FOOTER //
// ./src/reducers/help.ts